import { useState, useEffect } from 'react';
import { Container, BoxSelect, BtnSearch, FilterWrapper, Content, Title } from './styled';
import { ChartCompany } from './ChartCompany';
import { DatePicker, Search, Tabs, Tab } from '../../../../components';
import { IoIosSearch } from 'react-icons/io';
import moment from 'moment';
import { apiAdmin } from '../../../../service/api';
import { IdUser } from '../../../../contexts/auth';
import { IoAnalyticsOutline } from "react-icons/io5";

export function Consumption() {
    const [dateStart, setDateStart] = useState(
        moment().subtract(1, 'months').format('YYYY-MM-DD')
    );
    const [dateEnd, setDateEnd] = useState(
        moment().format('YYYY-MM-DD')
    );
    const [dataCompanies, setDataCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');
    const [activeTab, setActiveTab] = useState('video');

    const searchDataCompanies = async (dStart, dEnd) => {
        try {
            setLoading(true);
            setDataCompanies([]);

            const dtStartFormatted = moment(dStart).format('DD/MM/YYYY');
            const dtEndFormatted = moment(dEnd).format('DD/MM/YYYY');

            const [responseOld, responseNew] = await Promise.all([
                apiAdmin.post(`/tempo-videochamada?dt_ini=${dtStartFormatted}&dt_fim=${dtEndFormatted}&tipo_visao=M&usuario_id=${IdUser()}`),
                apiAdmin.get(`/relatorio-consumo-mensagem-whats?dt_start=${dStart}&dt_end=${dEnd}&usuario_id=${IdUser()}`)
            ]);

            const oldData = responseOld.data || [];

            let rawNewData = responseNew.data || [];
            if (!Array.isArray(rawNewData)) {
                rawNewData = rawNewData.relatorio || rawNewData.data || rawNewData.dados || rawNewData.consumo || [];
            }
            const newData = rawNewData.map(item => ({
                empresa: item.empresa_id || item.id || Math.random(),
                empresa_nome: item.empresa_nome || item.nome || 'Desconhecida',
                empresa_avatar: item.empresa_avatar || item.avatar,
                mensagens: item.mensagens || item.messages || [],
                totalMensagens: item.total || item.totalMensagens || 0
            }));

            const companyMap = {};
            const order = [];

            oldData.forEach(obj => {
                const { empresa, empresa_nome, empresa_avatar, dados } = obj;
                if (!companyMap[empresa]) {
                    companyMap[empresa] = { empresa, empresa_nome, empresa_avatar, dados: [...dados], mensagens: [], totalMensagens: 0 };
                    order.push(empresa);
                } else {
                    companyMap[empresa].dados.push(...dados);
                }
            });

            newData.forEach(obj => {
                const { empresa, empresa_nome, empresa_avatar, mensagens, totalMensagens } = obj;
                if (!companyMap[empresa]) {
                    companyMap[empresa] = { empresa, empresa_nome, empresa_avatar, dados: [], mensagens, totalMensagens };
                    order.push(empresa);
                } else {
                    companyMap[empresa].mensagens = mensagens;
                    companyMap[empresa].totalMensagens = totalMensagens;
                }
            });

            setDataCompanies(order.map(empresa => companyMap[empresa]));
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        searchDataCompanies(
            dateStart,
            dateEnd
        )
    }, []);

    function onFilter(obj) {
        const matchText = obj?.empresa_nome?.toLowerCase()?.includes(filter?.toLowerCase());
        
        let hasValue = false;
        if (activeTab === 'video') {
            hasValue = obj?.dados?.length > 0;
        } else if (activeTab === 'message') {
            hasValue = obj?.mensagens?.length > 0;
        }

        return matchText && hasValue;
    };

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={dateStart}
                            onChange={setDateStart}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={dateEnd}
                            onChange={setDateEnd}
                        />
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                searchDataCompanies(
                                    dateStart,
                                    dateEnd
                                )
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Title>
                <span>
                    <IoAnalyticsOutline fontSize={'3rem'} />
                </span>
                <div>
                    {`Relatório de Consumo`}
                </div>
            </Title>
            <FilterWrapper className={dataCompanies?.length === 0 ? 'disabled' : ''}>
                <Search
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder={`Buscar Empresa`}
                    className='input-filter'
                />
            </FilterWrapper>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
                <Tabs>
                    <Tab
                        className={activeTab === 'video' ? 'selected' : ''}
                        onClick={() => setActiveTab('video')}
                    >
                        Minutos de videochamada
                    </Tab>
                    <Tab
                        className={activeTab === 'message' ? 'selected' : ''}
                        onClick={() => setActiveTab('message')}
                    >
                        Mensagens
                    </Tab>
                </Tabs>
                <Content>
                    {dataCompanies?.length > 0 && dataCompanies?.filter(onFilter)?.map((company) => {
                        const { empresa } = company;
                        return (
                            <ChartCompany
                                className="chart"
                                key={empresa}
                                company={company}
                                objKey={'mes_extenso'}
                                activeTab={activeTab}
                            />
                        )
                    })}
                </Content>
            </div>
        </Container >
    );
}